// English dictionary
// Flat key → string for simple lookups. Keep keys sorted within each group
// for easy review.
export const en = {
  // ====== Navbar ======
  // ====== Navbar ======
  'nav.resources': 'Resources',
  'nav.controlRoom': 'Control room',
  'nav.signIn': 'Sign in',
  'nav.register': 'Register',
  'nav.signOut': 'Sign out',
  'nav.languageToggle': 'EN',

  // ====== Footer ======
  'footer.libraryOnline': 'Library online',
  'footer.builtForCreators': 'Built for creators',
  'footer.copyright': '© {year} CG Resource Hub',

  // ====== Home ======
  'home.toolTagHoudini': 'Houdini',
  'home.toolTagLiveService': 'Live Service',
  'home.toolTagHipRepair': 'HIP Repair',
  'home.toolTagFree': 'Free',
  'home.toolRunServerSide': 'Run server-side',
  'home.openTool': 'Open tool',
  'home.view': 'View',
  'home.downloadsCount': '{count} downloads',

  // ====== Login ======
  'login.signInSlash': '/ Sign in',
  'login.welcomeBack': 'Welcome back',
  'login.subtitle': 'Sign in to access the library',
  'login.usernameOrEmail': 'Username or email',
  'login.usernamePlaceholder': 'zhangsan or you@example.com',
  'login.password': 'Password',
  'login.passwordPlaceholder': '••••••••',
  'login.signInCta': 'Sign in',
  'login.signingIn': 'Signing in…',
  'login.or': 'or',
  'login.invitePrompt': 'Have an invite code?',
  'login.createAccount': 'Create account',
  'login.invalidCredentials': 'Invalid credentials',
  'login.loginFailed': 'Login failed',
  'login.hidePassword': 'Hide password',
  'login.showPassword': 'Show password',

  // ====== Register ======
  'register.accessDeniedSlash': '/ Access denied',
  'register.missingInviteTitle': 'Missing invitation code',
  'register.missingInviteBody':
    'Registration is invitation-based. Ask an existing member to share an invite link with you.',
  'register.backToSignIn': 'Back to sign in',
  'register.createAccountSlash': '/ Create account',
  'register.joinTheLibrary': 'Join the library',
  'register.inviteBased': 'Invitation-based registration',
  'register.invitationCode': 'Invitation code',
  'register.username': 'Username',
  'register.usernamePlaceholder': 'e.g. zhangsan',
  'register.emailOptional': 'Email (optional)',
  'register.emailPlaceholder': 'you@example.com',
  'register.password': 'Password',
  'register.passwordMin': 'Minimum 6 characters',
  'register.confirmPassword': 'Confirm password',
  'register.createCta': 'Create account',
  'register.creatingCta': 'Creating account…',
  'register.haveAccount': 'Already have an account?',
  'register.signIn': 'Sign in',
  'register.passwordMismatch': 'Passwords do not match',
  'register.registrationFailed': 'Registration failed',
  'register.unreachable': 'Unable to reach the server',

  // ====== ResourceDetail ======
  'detail.backToLibrary': 'Back to library',
  'detail.breadcrumb': '/ Resource / {category}',
  'detail.resourceNotFound': 'Resource not found',
  'detail.resourceNotFoundHint': 'It may have been removed or never existed',
  'detail.categoryUnreal': 'Unreal Engine',
  'detail.categoryResource': '{category} resource',
  'detail.technicalHighlights': '/ Technical highlights',
  'detail.spec': '/ Spec',
  'spec.blenderVersion': 'Blender',
  'spec.renderer': 'Renderer',
  'spec.frameRange': 'Frame range',
  'spec.fps': 'FPS',
  'spec.resolution': 'Resolution',
  'spec.lights': 'Lighting',
  'detail.videoDemo': '/ Video demo',
  'detail.videoTimeReal': '{time}',
  'detail.videoTimePlaceholder': '{time} — placeholder',
  'detail.demoBadge': 'Demo · 16:9',
  'detail.videoPlaceholderCaption': 'Video placeholder · upload coming soon',
  'detail.playVideo': 'Play demo video',
  'detail.screenshots': '/ Screenshots & results',
  'detail.frames': '4 frames',
  'detail.screenshot': 'Screenshot',
  'detail.categorized': '/ Categorized',
  'detail.tagSoftware': 'Software',
  'detail.tagElement': 'Element',
  'detail.tagTechnique': 'Technique',
  'detail.tags': '/ Tags',
  'detail.metaDownloads': 'Downloads',
  'detail.metaCategory': 'Category',
  'detail.metaAdded': 'Added',
  'detail.getAsset': 'Get this asset',

  // ====== Blend asset panel ======
  'detail.bl.blendBadge': 'Blender assets',
  'detail.bl.fullDownload': 'Download full pack',
  'detail.bl.assetCount': '{count} assets',
  'detail.bl.assetSingle': '1 asset',
  'detail.bl.assetMaterials': '{count} materials',
  'detail.bl.assetTextures': '{count} textures',
  'detail.bl.assetTriangles': '{count} triangles',
  'detail.bl.assetVertices': '{count} vertices',
  'detail.bl.assetHasArmature': 'Rigged',
  'detail.bl.assetDownload': 'Download this asset',
  'detail.bl.assetDownloading': 'Packing…',
  'detail.bl.assetFirstBuild': 'First build ~5–10s, then instant',
  'detail.bl.allResolved': 'All textures resolved',
  'detail.bl.someMissing': '{count} missing',
  'detail.bl.noMissing': 'None missing',
  'detail.bl.thumbnailGenerating': 'Thumbnail generating…',
  'detail.bl.version': 'Blender version',
  'detail.bl.actionsNone': 'No animations',

  // ====== ToolHipPathDoctor ======
  'tool.title': 'HIP Path Doctor',
  'tool.signInPrompt': 'Sign in to repair, swap, and rebase paths inside your .hip files.',
  'tool.signInCta': 'Sign in',
  'tool.registerCta': 'Register',
  'tool.liveService': 'Live Service',
  'tool.houdiniVersion': 'Houdini 22.0.368',
  'tool.titleWithAccent': 'HIP Path Doctor',
  'tool.lede':
    'Drop a .hip file. We surgically repair, swap, and rebase every path inside it — same logic as the yaopc::FolderPathFixed HDA, running on a Houdini server behind the curtain.',
  'tool.sectionFeatures': 'Pick a feature',
  'tool.sectionSteps': 'Steps for the selected feature',
  'tool.sectionUpload': 'Upload & run',
  'tool.featureSwitchSlash': 'Switch Slash',
  'tool.featureSwitchSlashDesc':
    'Normalize all backslashes to forward slashes in string parms.',
  'tool.featureReplace': 'Replace Path',
  'tool.featureReplaceDesc':
    'Find an old substring inside every parm and replace it with a new one.',
  'tool.featureFindMissing': 'Find Missing',
  'tool.featureFindMissingDesc':
    'List every file/filecache node whose path no longer exists on disk.',
  'tool.featureAbsRel': 'Switch Abs / Rel',
  'tool.featureAbsRelDesc':
    'Convert file paths between absolute form and base-relative var form.',
  'tool.stepSwitchSlash':
    'No extra options. Every backslash {bs} in a string parm becomes {fs}.',
  'tool.stepReplace': 'Fill in Old and New substrings, then run.',
  'tool.stepFindMissing':
    'The output is your original .hip unchanged — you get a report listing every file/filecache node that points to a missing path.',
  'tool.stepAbsRel': 'Pick a direction, choose a base, then run.',
  'tool.labelOld': 'Old substring',
  'tool.placeholderOld': 'e.g. D:\\old_project\\assets',
  'tool.labelNew': 'New substring',
  'tool.placeholderNew': 'e.g. G:\\projects\\shot010',
  'tool.labelDirection': 'Direction',
  'tool.labelBase': 'Base',
  'tool.labelCustomBase': 'Custom base path',
  'tool.placeholderCustomBase': 'e.g. $HIP/proj/ or /abs/path/',
  'tool.dirToAbs': '→ Absolute',
  'tool.dirToRel': '→ Relative',
  'tool.baseHip': '$HIP',
  'tool.baseJob': '$JOB',
  'tool.baseCustom': 'Custom',
  'tool.uploadTitle': 'Upload your .hip',
  'tool.dropPrompt': 'Drop your .hip here or click to browse',
  'tool.dropHint': '.hip / .hipnc · up to 100 MB',
  'tool.runCta': 'Run',
  'tool.processingCta': 'Processing…',
  'tool.errorOnlyHip': 'Only .hip or .hipnc files are accepted.',
  'tool.errorTooLarge': 'File too large. Max 100 MB.',
  'tool.errorDropFirst': 'Drop a .hip file first.',
  'tool.errorNeedOld': 'Replace needs an Old substring.',
  'tool.errorNeedCustomBase': 'Custom Base is required when Base = Custom.',
  'tool.errorDefault': 'Run failed.',
  'tool.resultDone': 'Done',
  'tool.resultSavedAs': 'Saved as {filename} in your Downloads folder.',
  'tool.resultAuditHint':
    'An audit log was written next to your .hip: {mdPath}',
  'tool.resultRedownload': 'Re-download',
  'tool.resultFallbackFindMissing':
    'Find Missing: scan complete.\n(see downloaded .hip for original, no changes written)',
  'tool.resultFallbackOther': '{name}: {count} parm(s) changed.',
  'tool.backToResources': 'Resources',

  // ====== ToolHipFormatBridge (added 2026-08-22) ======
  // Houdini can't natively open .3ds / .step / .iges / .dae / .ply / etc.
  // This tool runs FreeCAD on the server to convert the file to OBJ, then
  // hython packages it inside a fresh .hip with /obj/imported_geometry.
  'home.toolTagFormatBridge': 'Format Bridge',
  'home.toolTagImportMesh': '3D Mesh Import',
  'home.toolTagImportCad': 'CAD Import',
  'bridge.title': 'HIP Format Bridge',
  'bridge.signInPrompt':
    'Sign in to import 3D files Houdini can’t read into a fresh .hip scene.',
  'bridge.signInCta': 'Sign in',
  'bridge.registerCta': 'Register',
  'bridge.liveService': 'Live Service',
  'bridge.houdiniVersion': 'Houdini 22 + FreeCAD 1.0',
  'bridge.lede':
    'Drop a 3D file Houdini can’t open (.3ds, .step, .iges, .sat, .dae, .ply, …). The server converts it to a fresh .hip, with the geometry embedded as /obj/imported_geometry, ready to drop into your scene.',
  'bridge.sectionFormats': 'Supported source formats',
  'bridge.sectionUpload': 'Upload & run',
  'bridge.groupMesh': '3D mesh formats',
  'bridge.groupCad': 'CAD formats',
  'bridge.group2d': '2D drawings',
  'bridge.fmt3ds': '3D Studio',
  'bridge.fmt3mf': '3D Manufacturing Format',
  'bridge.fmtdae': 'Collada',
  'bridge.fmtply': 'Stanford PLY',
  'bridge.fmtstl': 'STL',
  'bridge.fmtoff': 'Object File Format',
  'bridge.fmtstep': 'STEP (AP214)',
  'bridge.fmtstp': 'STEP',
  'bridge.fmtiges': 'IGES',
  'bridge.fmtigs': 'IGES',
  'bridge.fmtsat': 'ACIS SAT',
  'bridge.fmtsab': 'ACIS SAB',
  'bridge.fmtbrep': 'OpenCascade BREP',
  'bridge.fmtdxf': 'AutoCAD DXF',
  'bridge.uploadTitle': 'Upload your 3D file',
  'bridge.dropPrompt': 'Drop your file here or click to browse',
  'bridge.dropHint': '.3ds .3mf .step .iges .sat .dxf … up to 200 MB',
  'bridge.runCta': 'Convert',
  'bridge.processingCta': 'Converting…',
  'bridge.errorOnly3d': 'Only supported 3D file types are accepted.',
  'bridge.errorTooLarge': 'File too large. Max 200 MB.',
  'bridge.errorDropFirst': 'Drop a 3D file first.',
  'bridge.errorDefault': 'Run failed.',
  'bridge.resultDone': 'Done',
  'bridge.resultSavedAs': 'Saved as {filename} in your Downloads folder.',
  'bridge.resultAuditHint':
    'An audit log was written next to your .hip: {mdPath}',
  'bridge.resultStats': 'Imported: {points} points, {prims} primitives',
  'bridge.resultContainer':
    'Container: /obj/imported_geometry (File SOP → Null)',
  'bridge.backToResources': 'Resources',

  // ====== 3DGS Auto Trainer (added 2026-08-22) ======
  // One-click COLMAP → Houdini ML 3DGS pipeline. The web tool uploads a
  // .zip of source images, the server runs gsplats_auto_trainer.py under
  // hython, and streams back a .hip + audit MD. Training itself is run
  // locally in Houdini (the cook is too long for an HTTP request).
  'home.toolTagGsplats': '3DGS Auto',
  'gsplats.title': '3DGS Auto Trainer',
  'gsplats.signInPrompt':
    'Sign in to convert a folder of images into a Houdini 3D Gaussian Splatting scene.',
  'gsplats.signInCta': 'Sign in',
  'gsplats.registerCta': 'Register',
  'gsplats.liveService': 'Live Service',
  'gsplats.houdiniVersion': 'Houdini 22 + COLMAP',
  'gsplats.lede':
    'Drop a .zip of source images. The server runs COLMAP, builds a Houdini scene with the ml_train_gsplats TOP network and a /obj/geo preview chain, and returns a ready-to-cook .hip. Open it in Houdini 22 to run the actual training.',
  'gsplats.sectionPipeline': 'Pipeline',
  'gsplats.sectionUpload': 'Upload & run',
  'gsplats.pipelineColmap': 'COLMAP (feature_extractor → matcher → mapper → model_converter, OPENCV camera model)',
  'gsplats.pipelineTop': '/tasks/ml_train_gsplats — VRAM-cached, max batch 6, no testing export',
  'gsplats.pipelineSop': '/obj/geo — file → bakegsplats → transform → group(bbox) → blast → OUT_SPLAT',
  'gsplats.labelProjectName': 'Project name',
  'gsplats.placeholderProjectName': 'e.g. white_lion',
  'gsplats.helpProjectName': 'Used for the dataset folder name and the .hip filename. Alphanumeric + underscore.',
  'gsplats.labelDownscale': 'Image downscale',
  'gsplats.downscaleFull': 'Full (1×)',
  'gsplats.downscaleHalf': 'Half (½)',
  'gsplats.downscaleQuarter': 'Quarter (¼)',
  'gsplats.labelMaxBatch': 'Max batch size',
  'gsplats.helpMaxBatch': 'Lower if your GPU is small; 6 fits a single 24 GB card.',
  'gsplats.labelBbox': 'Preview bounding box (½-extent)',
  'gsplats.helpBbox': 'Half-extent in Houdini units; full box = 2× this value per axis.',
  'gsplats.labelDryRun': 'Dry-run (skip COLMAP + cook)',
  'gsplats.helpDryRun':
    'Useful when COLMAP is not installed or you just want to verify the .hip structure. Builds the dataset tree + .hip with stub sparse/0/.',
  'gsplats.uploadTitle': 'Upload your image .zip',
  'gsplats.dropPrompt': 'Drop a .zip of images here, or click to browse',
  'gsplats.dropHint': '.zip · up to 500 MB',
  'gsplats.runCta': 'Build .hip',
  'gsplats.processingCta': 'Building…',
  'gsplats.errorOnlyZip': 'Only .zip files are accepted. Zip your image folder before uploading.',
  'gsplats.errorTooLarge': 'File too large. Max 500 MB.',
  'gsplats.errorDropFirst': 'Drop a .zip of images first.',
  'gsplats.errorNeedProjectName': 'Project name is required (alphanumeric / underscore).',
  'gsplats.errorDefault': 'Run failed.',
  'gsplats.resultDone': 'Done',
  'gsplats.resultSavedAs': 'Saved as {filename} in your Downloads folder.',
  'gsplats.resultAuditHint':
    'An audit log was written next to your .hip: {mdPath}',
  'gsplats.resultRedownload': 'Re-download',
  'gsplats.resultDryRunNote':
    'Dry-run mode: sparse/0/ contains a stub. Re-run without Dry-run to populate real COLMAP output.',
  'gsplats.backToResources': 'Resources',

  // ====== Taxonomy: filters & badges (Home / Detail) ======
  'home.filterAll': 'All',
  'home.filterCategory': 'Software',
  'home.filterType': 'Type',
  'home.filterPrice': 'Price',
  'home.filterSort': 'Sort',
  'home.sortNew': 'Newest',
  'home.sortDownloads': 'Most downloaded',
  'home.filterClear': 'Clear',
  'home.filterEmpty': 'No resources match these filters.',
  'home.badgeFree': 'Free',
  'home.badgePaid': 'Paid',

  // ====== Taxonomy: resource types ======
  'resourceType.plugin': 'Plugin / Script',
  'resourceType.preset': 'Preset / Template',
  'resourceType.material': 'Material / Texture',
  'resourceType.model': 'Model / Asset',
  'resourceType.project': 'Project File',
  'resourceType.tutorial': 'Tutorial / Doc',
  'resourceType.aiworkflow': 'AI Workflow Pack',
  'resourceType.audio': 'Audio / Music',

  // ====== Taxonomy: licenses ======
  'license.cc0': 'CC0',
  'license.mit': 'MIT',
  'license.gpl': 'GPL',
  'license.commercial': 'Commercial',

  // ====== Taxonomy: languages ======
  'language.zh': 'Chinese',
  'language.en': 'English',
  'language.localized': 'Localized',
} as const;

// Derive the canonical key union from the english dictionary so zh.ts
// (and any future locale) can be type-checked at compile time — a missing
// key in zh.ts becomes a TS error instead of a runtime fallback.
export type DictKey = keyof typeof en;
